import { Link } from 'react-router-dom';
import { SITE_NAME, SITE_DOMAIN } from '../constants/site';
import { CONTACT } from '../constants/contact';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="dh-footer">
      <div className="dh-container dh-footer__grid">
        <div className="dh-footer__brand">
          <Link to="/" className="dh-footer__logo">
            {SITE_NAME}
          </Link>
          <p>
            Independent Dragon NaturallySpeaking support and licensed edition guidance at{' '}
            {SITE_DOMAIN}.
          </p>
        </div>
        <div>
          <h3>Policies</h3>
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-service">Terms of Service</Link>
            </li>
            <li>
              <Link to="/refund-policy">Refund and Returns Policy</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>Contact</h3>
          <ul>
            <li>
              <a href={CONTACT.phoneTel}>{CONTACT.phone}</a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </li>
            <li>{CONTACT.company}</li>
            <li>{CONTACT.addressLine1}</li>
            <li>{CONTACT.addressLine2}</li>
          </ul>
        </div>
      </div>
      <div className="dh-footer__bottom">
        <p>
          Copyright © {new Date().getFullYear()} {SITE_NAME}. All rights reserved. Operated by{' '}
          {CONTACT.company}. Dragon and related trademarks belong to their respective owners. This
          site is an independent service and is not an official Nuance or Microsoft website.
        </p>
      </div>
    </footer>
  );
}
